import React from 'react';
import { motion } from 'framer-motion';
export function Welcome() {
  return <section className="py-24 md:py-32 bg-sand-light overflow-hidden" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-268">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-269">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl relative z-10" data-id="element-270">
              <img src="https://cdn.magicpatterns.com/uploads/kVxG7fXPnRN7PDeQXGT3Ek/EL_MIRADOR_CABANAS_ACTUALIZADA.jpg" alt="Cabañas El Mirador rodeadas de naturaleza" className="w-full h-full object-cover" data-id="element-271" />
            </div>
            {/* Decorative background element */}
            <div className="absolute -bottom-8 -left-8 w-2/3 h-2/3 bg-sand-dark/30 rounded-2xl -z-10" data-id="element-272"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-273">
            <h2 className="text-4xl md:text-5xl text-olive-dark mb-8 leading-tight" data-id="element-274">
              Un lugar pensado para desconectar
            </h2>
            <div className="space-y-6 text-lg text-charcoal-light leading-relaxed" data-id="element-275">
              <p data-id="element-276">
                En{' '}
                <strong className="text-olive font-medium" data-id="element-277">
                  Cabañas El Mirador
                </strong>{' '}
                te invitamos a vivir una estadía de descanso, tranquilidad y
                contacto con la naturaleza.
              </p>
              <p data-id="element-278">
                Ubicadas en El Durazno, Yacanto de Calamuchita, nuestras cabañas
                ofrecen comodidad, calidez y un entorno privilegiado para
                disfrutar de las sierras de Córdoba en cualquier época del año.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}